<template>
  <div class="steps">
    <p
      class="steps__title--mobile ml-5 md:ml-0"
    >
      {{ $t('auto_investment.setup.risk_rating.title') }}
    </p>
    <p
      class="
        text-sm text-grey-2
        font-semibold
        lg:font-normal
        text-opacity-80 text-left
        mb-12
      "
    >
      {{ $t('auto_investment.setup.risk_rating.subtitle') }}
    </p>
    <Slider
      v-model="riskRating"
      :min="0"
      :max="99.9"
      :step="11.1"
      :tooltips="true"
      :format="formatRiskTooltip"
      class="slider-auto-investment"
    />
    <div class="flex justify-between mt-6">
      <p
        class="font-bold text-grey-2 text-base"
      >
        A+
      </p>
      <p
        class="font-bold text-grey-2 text-base"
      >
        D
      </p>
    </div>
    <p
      class="text-sm text-grey-3 bg-grey-7 p-4 mt-8 mb-8 rounded-3xl"
      v-html="$t('auto_investment.setup.risk_rating.info_box' + extra)"
    />
    <GpButton
      mobileWidth="w-4/5"
      class="absolute lg:right-24 mx-auto lg:m-0"
      @click="next"
    >
      {{ $t('onboarding.continue') }}
    </GpButton>
  </div>
</template>

<script>
import { useStore } from 'vuex'
import { ref, watch } from 'vue'
import GpButton from '@/components/general/GpButton.vue'
import Slider from '@vueform/slider'
import useStrategies from '@/mixins/useStrategies.js'

export default {
  components: {
    GpButton,
    Slider
  },
  setup(props, { emit }) {
    const store = useStore()
    const riskRating = ref(55.5)
    const extra = ref('')

    const { levelRisk, valueRisk } = useStrategies()

    async function next() {
      store.dispatch('updateNewAutoInvestment', {
        max_risk: valueRisk(levelRisk(riskRating.value))
      })
      emit('next')
    }

    const formatRiskTooltip = (value) => {
      return levelRisk(parseFloat(value.toFixed(1)))
    }

    watch(
      () => riskRating,
      () => {
        if (riskRating.value == 0) {
          extra.value = '_a_plus'
        } else if (riskRating.value == 66.6) {
          extra.value = '_c_plus'
        } else {
          extra.value = ''
        }
      },
      { deep: true }
    )

    return {
      next,
      formatRiskTooltip,
      riskRating,
      extra
    }
  }
}
</script>
